export const PANICKED = 'panicked'
export const FLUSTERED = 'flustered'
export const BATHING = 'bathing'
export const SINGING = 'singing'
